<template>
  <v-layout ref="wrapper" :style="{'clear': 'both', 'position': 'relative', 'margin-left': 'auto', 'margin-right': 'auto'}">
    <svg v-show="expanded" v-if="chart.reports && chart.reports.length > 0" id="lines" :ref="'lines' + id" 
        v-bind:style="{'position': 'absolute', 'min-width': `${(maxLinePointWidth + 200) * (1 / whichPageToShow)}px`, 'min-height': `${(maxLinePointHeight + 200) * (1 / whichPageToShow)}px`}"> </svg>
    <v-flex :style="{'position': 'relative', 'min-width': `${minWidth ? minWidth : 400}px`}" ref="firstChild">
      <v-flex v-show="expanded" column justify-center>
      <v-card v-if="whichPageToShow >= 0.75" :style="{'height': orgCardHeight + 'px', 'width': this.orgCardWidth + 'px', 'left': this.ignoreMargin ? '0%' : `50%`}" class="org-chart-user justify-center"  justify-center ref='main'>
      <v-card-title :style="{'background-color': (chart.department === 'Engineering' ? 'rgba(200,0,0,0.2)' : (chart.department === 'Operations' ? 'rgba(0,0,200,0.2)' : (chart.department === 'Marketing' ? 'rgba(211, 84, 0, 0.2)' : 'rgba(249, 191, 59, 1)'))), 'margin-bottom':'20px'}" class="justify-space-between">
        <v-avatar size="100" class="elevation-20" style="position: absolute; top:-75px; left: calc(50% - 50px); z-index:100">
          <v-img
          
          :src="chart.person ? chart.person.imageUrl : require('../assets/OpenPosition.jpg')"
          ></v-img>
        </v-avatar>
        <!-- <v-icon  style="position:absolute; left:10px; top:10px; padding:3px; cursor: grab">fas fa-expand-arrows-alt</v-icon> -->
        <!-- <v-btn  style="position:absolute; right:10px; top:10px">edit</v-btn> -->
        <span  class="caption" style="position:absolute; right:10px; bottom:10px"><i>* indicates a custom field is only visible to administrators</i></span>
        <v-flex  column>
          <span v-if="chart.person"  class="title" style="display:block; margin-top:20px">{{chart.person.firstName}} {{chart.person.lastName}}</span>
            <span v-else  class="title" style="display:block; margin-top:20px">Open Position</span>
          <v-divider  />
          <span  class="subtitle-1">{{chart.jobTitle}}</span>
        </v-flex>
      </v-card-title>
       <v-flex  column justify-center style="max-height: 90%;">
            <span  class="body-2" ma-5 style="margin-right: 10px; margin-left:20px; display:block;"><b>Department</b>: {{chart.department}}</span>
            <span  v-if="chart.person"  class="body-2" ma-5 style="margin-right: 10px; margin-left:20px; display:block;"><b>Hire Date</b>: {{chart.person.hireDate ? chart.person.hireDate.toLocaleDateString("en-US") : new Date(Math.random() * new Date().getTime()).toDateString()}}</span>
            <span  class="body-2" ma-5 style="margin-right: 10px; margin-left:20px; display:block;"><b><i>Budgeted Hours*</i></b>: {{chart.budgetedHours}}</span>
            <span  class="body-2" ma-5 style="margin-right: 10px; margin-left:20px; display:block;"><b><i>Salary*</i></b>: ${{chart.salary}}</span>
        </v-flex>
        <v-btn v-if="chart.reports && chart.reports.length"  width="50" height="50" style="position: absolute; bottom:-25px; left: calc(50% - 25px); z-index:100" icon @click="toggleExpand">
          <v-icon v-show="expanded">fas fa-minus-circle</v-icon>
          <v-icon v-show="!expanded">fas fa-plus-circle</v-icon>
        </v-btn>
    </v-card>
    <v-card v-else :style="{'height': orgCardHeight + 'px', 'width': this.orgCardWidth + 'px', 'left': this.ignoreMargin ? '0%' : `50%`}" class="org-chart-user justify-center"  justify-center ref='main'>
    <v-card-title  :style="{'height': '100%', 'background-color': (chart.department === 'Engineering' ? 'rgba(200,0,0,0.2)' : (chart.department === 'Operations' ? 'rgba(0,0,200,0.2)' : (chart.department === 'Marketing' ? 'rgba(211, 84, 0, 0.2)' : 'rgba(249, 191, 59, 1)')))}" class="justify-space-between">
      <v-avatar  size="150" class="elevation-20" style="position: absolute; top:-75px; left: calc(50% - 75px); z-index:100">
        <v-img
        
        :src="chart.person ? chart.person.imageUrl : require('../assets/OpenPosition.jpg')"
        ></v-img>
      </v-avatar>
      <!-- <v-icon  style="position:absolute; left:10px; top:10px; padding:3px; cursor: grab">fas fa-expand-arrows-alt</v-icon> -->
      <!-- <v-btn  style="position:absolute; right:10px; top:10px">edit</v-btn> -->
      <v-flex  column>
        <span v-if="chart.person"  class="display-2" style="display:block; margin-top:50px">{{chart.person.firstName}} {{chart.person.lastName}}</span>
          <span v-else  class="display-2" style="display:block; margin-top:50px">Open Position</span>
        <v-divider v-if="whichPageToShow >= 0.45" />
        <span  v-if="whichPageToShow >= 0.45" class="headline">{{chart.jobTitle}}</span>
      </v-flex>
    </v-card-title>
    <v-btn v-if="chart.reports && chart.reports.length"  width="100" height="100" style="position: absolute; bottom:-50px; left: calc(50% - 50px); z-index:100" icon @click="toggleExpand">
      <v-icon size="50" v-show="expanded">fas fa-minus-circle</v-icon>
      <v-icon size="50" v-show="!expanded">fas fa-plus-circle</v-icon>
    </v-btn>
    </v-card>
    <v-flex :class="{ 'row': chart.reportsHorizontal, 'column': !chart.reportsHorizontal}" v-show="expanded" v-if="chart.reports && chart.reports.length > 0" :style="{'margin-top': `${orgCardHeight / 2}px`, 'flex-wrap': 'nowrap', 'width': '100%'}">
      <ChartBox ref="child" :panzoomInstance=panzoomInstance :currentX=currentX :currentY=currentY :scale=1 :whichPageToShow=whichPageToShow :mappingScale=mappingScale :key=j v-for="(report, j) in orderedReports" :chart=report :id="id + j + 1"
      :style="{'min-width': `${report.reportsHorizontal ? (report.reports.length + 1) * 600 : 600}px`, 'width': `100%`, 'min-height': `${orgCardHeight}px`, 'margin-left': `${(orgCardWidth / 4)}px`, 'margin-top': `${orgCardHeight / 3}px`}">
        </ChartBox>
    </v-flex>
    </v-flex>
    </v-flex>
  </v-layout>
</template>
<script>
import { dragscroll } from 'vue-dragscroll'
export default {
    props: ['chart', 'id', 'ignoreMargin', 'scale', 'mappingScale', 'whichPageToShow', 'currentX', 'currentY', 'panzoomInstance'],
    name: 'ChartBox',
    mounted() {
      this.drawLines()
    },
    directives: {
      'dragscroll': dragscroll
    },
    data: function() {
      return {
        expanded: true,
        maxLinePointWidth: 0,
        maxLinePointHeight: 0,
        minWidth: 0,
        childrenWidthMin: Number.MAX_SAFE_INTEGER,
        childrenWidthMax: Number.MIN_SAFE_INTEGER,
        childrenHeightMin: Number.MAX_SAFE_INTEGER,
        childrenHEightMax: Number.MIN_SAFE_INTEGER,
      }
    },
    computed: {
      orgCardWidth: function () {
        return 500
      },
      orgCardHeight: function () {
        return 250
      },
      orderedReports: function() {
        return this.chart.reports.sort((a,b) => {
          return a.reports.length - b.reports.length
        })
      }
    },
    watch: {
      chart: function() {
        this.expanded = true
        setTimeout((() => this.drawLines(!!this.minWidth)), 1)
      }
    },
    methods: {
      toggleExpand: function() {
        this.expanded = !this.expanded
        setTimeout(this.drawLines, 1)
      },
      getMainBoundingBox: function() {
        return this.$refs.main.$el.getBoundingClientRect()
      },
      rotate: function() {

      },
      zoomToMain: function() {
        var mainBoundingBox = this.getMainBoundingBox()
        var deltaX = mainBoundingBox.right;
        var deltaY = mainBoundingBox.bottom;
        this.panzoomInstance.smoothZoom(deltaX * -0.15, deltaY * -0.12, this.$vuetify.breakpoint.smAndDown ? 0.2 : 0.3);
        setTimeout(this.drawLines,700)
      },
      drawLines: function(resetMinWidth = false) {
        let maxWidth = []
        let maxHeight = []
        let minWidth = []
        let minHeight = []
        var svgComponent = this.$refs['lines' + this.id]
        let wrapperBoundingBox = this.$refs.wrapper.getBoundingClientRect()
        var parentBoundingBox = this.$refs.main.$el.getBoundingClientRect()
        if (svgComponent) {
        while (svgComponent.firstChild) {
          svgComponent.removeChild(svgComponent.firstChild);
        }
        var multiplier = 1 / this.whichPageToShow
        var svgBoundingBox = svgComponent.getBoundingClientRect()
        var parentCenterWidth = (parentBoundingBox.left + ((parentBoundingBox.width) / 2)) - svgBoundingBox.left
        var parentCenterHeight = parentBoundingBox.top - svgBoundingBox.top
        maxWidth.push(parentBoundingBox.right + parentBoundingBox.x)
        maxHeight.push(parentBoundingBox.bottom + parentBoundingBox.y)
        minWidth.push(parentBoundingBox.left + parentBoundingBox.x)
        minHeight.push(parentBoundingBox.top + parentBoundingBox.y)
        var childrenBoundingBox = this.$refs['child']
        let maxXPositions = childrenBoundingBox.map(xy => xy.drawLines()).filter(x => !!x)
        for (var i = 0; i < childrenBoundingBox.length; i ++) {
          var childBox = childrenBoundingBox[i]
          var childBoundingBox = childBox.getMainBoundingBox()
          maxXPositions.push(childBoundingBox.right)
          var newpath = document.createElementNS('http://www.w3.org/2000/svg',"path");  
          var childCenterWidth = (childBoundingBox.left + (childBoundingBox.width / 2)) - svgBoundingBox.left
          var childCenterHeight = childBoundingBox.top - svgBoundingBox.top
          maxWidth.push(childBoundingBox.right - wrapperBoundingBox.left + parentBoundingBox.width)
          maxHeight.push(childBoundingBox.bottom - wrapperBoundingBox.top)
          minWidth.push(childBoundingBox.right - wrapperBoundingBox.left)
          minHeight.push(childBoundingBox.bottom - wrapperBoundingBox.top)
          let mappedWidthPoints = []
          let mappedHeightPoints = []
        if (this.chart.reportsHorizontal) {
          mappedWidthPoints.push(parentCenterWidth, childCenterWidth)
          mappedHeightPoints.push(parentCenterHeight, (parentCenterHeight + parentBoundingBox.height * 1.3), childCenterHeight)
          newpath.setAttributeNS(null, "d", `M${parentCenterWidth * multiplier} ${parentCenterHeight * multiplier} L${parentCenterWidth * multiplier} ${(parentCenterHeight + parentBoundingBox.height * 1.3) * multiplier} L${childCenterWidth * multiplier} ${(parentCenterHeight + parentBoundingBox.height * 1.3) * multiplier} L${childCenterWidth * multiplier} ${childCenterHeight * multiplier}`);
        } else {
            mappedWidthPoints.push(parentCenterWidth, (childCenterWidth + parentBoundingBox.width / 1.5), childCenterWidth)
            mappedHeightPoints.push(parentCenterHeight, (parentCenterHeight + parentBoundingBox.height * 1.15), childCenterHeight, (childCenterHeight + parentBoundingBox.height / 2))
            newpath.setAttributeNS(null, "d", `M${parentCenterWidth * multiplier} ${parentCenterHeight * multiplier} L${parentCenterWidth * multiplier} ${(parentCenterHeight + parentBoundingBox.height * 1.15) * multiplier} L${(childCenterWidth + parentBoundingBox.width / 1.5) * multiplier} ${(parentCenterHeight + parentBoundingBox.height * 1.15) * multiplier} L${(childCenterWidth + parentBoundingBox.width / 1.5) * multiplier} ${(childCenterHeight + parentBoundingBox.height / 2) * multiplier} L${childCenterWidth * multiplier} ${(childCenterHeight + parentBoundingBox.height / 2) * multiplier}`);
        }
          newpath.setAttribute("stroke-width", `${3 * multiplier}`)
          newpath.setAttribute("fill", "none")
          newpath.setAttribute("stroke", `rgba(200,200,200, 1)`)
          //newpath.setAttribute("stroke", `rgba(${Math.random() * 255}, ${Math.random() * 255}, ${Math.random() * 255}, 0.8)`)
          //newpath.setAttribute("stroke-dasharray", "4")
          svgComponent.appendChild(newpath)
          this.childrenWidthMin = this.childrenWidthMin > Math.min(mappedWidthPoints) ? Math.min(mappedWidthPoints) : this.childrenWidthMin
          this.childrenWidthMax = this.childrenWidthMax < Math.max(mappedWidthPoints) ? Math.max(mappedWidthPoints) : this.childrenWidthMin
          this.childrenHeightMin = this.childrenHeightMin > Math.min(mappedHeightPoints) ? Math.min(mappedHeightPoints) : this.childrenHeightMin
          this.childrenHeightMax = this.childrenHeightMax < Math.max(mappedHeightPoints) ? Math.max(mappedHeightPoints) : this.childrenHeightMin
        }
        this.maxLinePointWidth = Math.max(...maxWidth)
        this.maxLinePointHeight = Math.max(...maxHeight)
        this.minLinePointWidth = Math.min(...minWidth)
        this.minLinePointHeight = Math.min(...minHeight)
        if (this.minWidth === 0 || resetMinWidth) {
          this.minWidth = (Math.max(...maxXPositions) - svgBoundingBox.left + 50 * (0.1 / this.whichPageToShow)) * (this.id === 0 ? (multiplier / 1.1) : 1)
          setTimeout(this.drawLines, 1)
          if (this.id === 0 && !resetMinWidth) {
            setTimeout(this.zoomToMain, 500)
          }
        }
        return Math.max(...maxXPositions)
      }
      }
    }
}
</script>

<style lang="scss" scoped>
</style>
